import React from 'react'
import { CmsBlock } from 'lib/shared/__DEPRECATED__/CmsBlock'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Container } from './components/Styled'

export const FAQs = () => {
  return (
    <Container>
      <CmsBlock
        id={CMS_BLOCK.FOOTER_FAQS}
      >
        {({ isFailure, content }) => {
          if (isFailure) {
            if (!process.env.REACT_APP_ENABLE_CMS_BLOCK_SAMPLE_DATA) {
              return null
            }

            return (
              <SampleData />
            )
          }
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          )
        }}
      </CmsBlock>
    </Container>
  )
}

const SampleData = () => {
  return (
    <>
      <h2>FAQs</h2>
      <ul className='footer__fqa'>
        <li><a href='/'>So, how does Sofia & Grace really work?</a></li>
        <li><a href='/'>How do I pass this product quiz?</a></li>
        <li><a href='/'>Do you have advice on managing my leaks?</a></li>
        <li className='footer__fqa-more'><a href='/'>More FAQs</a></li>
      </ul>
    </>
  )
}
